"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const input_styles_1 = require("./input.styles");
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const InputComponent = (0, react_1.forwardRef)(({ type, className, value, onChange, onBlur, placeHolder = '', labelText, hasError, errMsg, leftElement, rightElement, disabled, style, hintText, isAdrillaInput, onfocus, disableCopy, disablePaste, onKeyUp, dataTestId, inputMode = 'text', pattern = '', }, ref) => {
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const onCopy = (e) => {
        if (disableCopy) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            return false;
        }
    };
    const onPaste = (e) => {
        if (disablePaste) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            return false;
        }
    };
    return (react_1.default.createElement(input_styles_1.InputContainer, { className: className, style: style, theme: theme, colors: colors },
        react_1.default.createElement(input_styles_1.InputAndLabel, null,
            react_1.default.createElement(input_styles_1.InputElement, { ref: ref, className: `inputField ${(0, classnames_1.default)({
                    hasValue: value,
                    hasError: hasError,
                    hasLeftIcon: leftElement,
                    hasRightIcon: rightElement,
                })}`, type: type || 'text', value: value, onChange: onChange, onBlur: onBlur, placeholder: placeHolder, disabled: disabled, theme: theme, colors: colors, onFocus: onfocus, onCopy: onCopy, onPaste: onPaste, onKeyUp: onKeyUp, "data-testid": dataTestId, inputmode: inputMode, pattern: pattern }),
            labelText && (react_1.default.createElement(input_styles_1.InputLabel, { theme: theme, colors: colors, className: `${(0, classnames_1.default)({ shiftRight: leftElement })}` }, labelText)),
            leftElement && (react_1.default.createElement(input_styles_1.LeftIcon, { theme: theme, colors: colors }, leftElement)),
            rightElement && (react_1.default.createElement(input_styles_1.RightIcon, { className: `${(0, classnames_1.default)({ isAdrilla: isAdrillaInput })}`, theme: theme, colors: colors }, rightElement))),
        hasError && (react_1.default.createElement(input_styles_1.ErrorMessage, { theme: theme, colors: colors }, errMsg)),
        !hasError && hintText && (react_1.default.createElement(input_styles_1.HintText, { theme: theme, colors: colors }, hintText))));
});
exports.default = InputComponent;
//# sourceMappingURL=input.js.map